<template>
  <div class="pay-result">
    <img class="icon-state" v-if="$route.query.state == 0" src="https://xhdata.wan4.com/wsw-h5-41.png">
    <img class="icon-state" v-else src="https://xhdata.wan4.com/wsw-h5-42.png">
    <span class="start-txt">{{ $route.query.state == 0 ? '交易关闭' : '支付成功' }}</span>

    <van-button class="to-order-btn" type="primary" @click="goOrder()">查看订单</van-button>

    <van-button class="to-home-btn" type="primary" plain @click="goHome()">回到首页</van-button>
  </div>
</template>

<script>
export default {
  name: 'payResult',
  data() {
    return {

    }
  },
  created() {
  },
  components: {

  },
  methods: {
    goHome() {
      // 返回首页
      this.$router.replace('/');
    },
    goOrder() {
      if(this.$route.query.state == 0){
        this.$router.replace('/order/details?paymentSn='+this.$route.query.paymentSn);
      }else{
        this.$router.replace('/user');
      }
      
    }
  }
}
</script>

<style scoped lang="less">
.pay-result {
  min-height: calc(100% - 88px);
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 240px 0;

  .icon-state {
    width: 128px;
    height: 128px;
  }

  .start-txt {
    color: #333;
    font-size: 46px;
    font-style: normal;
    font-weight: 600;
    line-height: 62px;
    margin-top: 32px;
  }

  >button {
    width: 382px;
    height: 88px;
    border-radius: 88px;
    font-size: 32px;
    font-weight: 400;
  }

  .to-order-btn {
    margin-top: 100px;
  }

  .to-home-btn {
    margin-top: 32px;
    background: #fff;
  }
}
</style>
